import { useEffect } from "react";
import { AppointmentType, Discount } from "types";
import { untransformAppointmentType } from "helpers";
import { useGetDoctorFeesMutation } from "features/api";
import FeesTable from "./FeesTable";

interface DoctorFeesProps {
  id: string;
  type: AppointmentType;
  discount: Discount;
  size?: number;
}

const DoctorFees: React.FC<DoctorFeesProps> = ({
  id,
  type: typeProp,
  discount,
  size = 0,
}) => {
  const [fetch, { data, isError }] = useGetDoctorFeesMutation();
  const { bookingFee, professionalFee, transactionFee, roundedOff } = data || {
    bookingFee: 0,
    professionalFee: 0,
    transactionFee: 0,
    roundedOff: 0,
  };
  const type = untransformAppointmentType(typeProp);

  useEffect(() => {
    fetch({ id, type });
  }, [fetch, id, type]);

  if (isError) {
    return <div>Something went wrong</div>;
  } else {
    return (
      <FeesTable
        booking={bookingFee}
        professional={professionalFee}
        transaction={transactionFee}
        total={roundedOff}
        discount={discount}
        size={size}
      />
    );
  }
};

export { DoctorFees };
